import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Collapse,
  IconButton,
  Chip,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Assignment as AssignmentIcon,
  HourglassEmpty as HourglassEmptyIcon,
  CheckCircle as CheckCircleIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';

const SavStatsBanner = ({ stats, loading }) => {
  const [expanded, setExpanded] = useState(false);

  if (loading || !stats) {
    return null;
  }

  const {
    total = 0,
    nonTraite = 0,
    enCours = 0,
    fini = 0,
    actionStats = [],
  } = stats;

  const getActionLabel = (action) => {
    const labels = {
      remboursement: 'Remboursement',
      changement: 'Changement',
      avoir: 'Avoir',
      reparation: 'Réparation',
      autre: 'Autre',
    };
    return labels[action] || action;
  };

  return (
    <Paper
      sx={{
        mb: 3,
        p: 2,
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(255, 255, 255, 0.1)',
        },
        transition: 'box-shadow 0.3s ease',
      }}
      onClick={() => setExpanded(!expanded)}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center" gap={2} flex={1}>
          <AssignmentIcon color="primary" />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Statistiques SAV
          </Typography>
          <Chip
            label={`Total: ${total}`}
            color="primary"
            size="small"
            sx={{ ml: 2 }}
          />
          <Chip
            icon={<HourglassEmptyIcon />}
            label={`Non traité: ${nonTraite}`}
            color="warning"
            size="small"
          />
          <Chip
            icon={<TrendingUpIcon />}
            label={`En cours: ${enCours}`}
            color="info"
            size="small"
          />
          <Chip
            icon={<CheckCircleIcon />}
            label={`Fini: ${fini}`}
            color="success"
            size="small"
          />
        </Box>
        <IconButton size="small">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Répartition par statut
              </Typography>
              <Box display="flex" flexDirection="column" gap={1}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2">Non traité</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {nonTraite} ({total > 0 ? Math.round((nonTraite / total) * 100) : 0}%)
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2">En cours</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {enCours} ({total > 0 ? Math.round((enCours / total) * 100) : 0}%)
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2">Fini</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {fini} ({total > 0 ? Math.round((fini / total) * 100) : 0}%)
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Répartition par action
              </Typography>
              <Box display="flex" flexDirection="column" gap={1}>
                {actionStats && actionStats.length > 0 ? (
                  actionStats.map((stat) => (
                    <Box key={stat.action} display="flex" justifyContent="space-between">
                      <Typography variant="body2">{getActionLabel(stat.action)}</Typography>
                      <Typography variant="body2" fontWeight="bold">
                        {stat.count}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Aucune donnée disponible
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default SavStatsBanner;
